<header obg-m-navbar (back)="onNavbarCloseClick()" [options]="navbarOptions" titleText="verification.title"></header>
<div class="content">
	<ng-container *ngIf="isPhoneVerificationEnabled; else phoneVerificationDisabled">
		<h6>{{ 'verification.subtitle' | translate }}</h6>
		<obg-accordion
			*ngIf="isPhoneVerificationEnabled"
			(toggleChange)="accordionStateChanged($event)"
			[options]="accordionOptions"
			[expanded]="[expandedAccordion]"
		>
			<obg-accordion-header-component
				titleText="verification.document"
				[key]="kyc"
				(click)="onAccordionHeaderClick(kyc)"
				[expanded]="getExpanded(kyc)"
			>
			</obg-accordion-header-component>
			<obg-accordion-content [key]="kyc">
				<obg-m-kyc-verification-container
					*ngIf="expandedAccordion === kyc"
					useOverlayLoader
					hideTitle
				></obg-m-kyc-verification-container>
			</obg-accordion-content>

			<obg-accordion-header-component
				titleText="verification.sms"
				[key]="phoneVerification"
				(click)="onAccordionHeaderClick(phoneVerification)"
				[expanded]="getExpanded(phoneVerification)"
			>
			</obg-accordion-header-component>
			<obg-accordion-content [key]="phoneVerification">
				<obg-m-phone-verification-container></obg-m-phone-verification-container>
			</obg-accordion-content>
		</obg-accordion>
	</ng-container>

	<ng-template #phoneVerificationDisabled>
		<obg-m-kyc-verification-page useOverlayLoader hideTitle></obg-m-kyc-verification-page>
	</ng-template>
</div>
